import {Assert} from "common/Assert";
import {LoggingService} from "logging/LoggingService";

/***********************************************************************
 * returns the better value of two given scores
 * @param {String} scoreValue
 * @return {String} score
 ***********************************************************************/
function castStringScoreToNumber( scoreValue ) {
    const score = typeof(scoreValue) === "string" ? Number(scoreValue) : scoreValue;
    Assert.checkState(!isNaN(score));
    return score;
}

class ScormUtilsClass {

    constructor(){}

    /***********************************************************************
     * inserts new children to a SCORM-childlist, in case there are not already
     * present in list. The list-delimiter must be ","
     * @param {String} childList comma separated value list
     * @param {String} insertList comma separated value list to merge to the childlist
     * @return {String} new comma separated value list
     ***********************************************************************/
    insertChildren(childList, insertList) {

        Assert.checkArgumentType( childList, "string" );
        Assert.checkArgument( insertList );
        Assert.checkArgumentType( insertList, "string" );

        let newChildList = childList,
            asInsert = insertList.split(","),
            i;

        for( i = 0; i < asInsert.length; i++ ) {
            if (newChildList.indexOf(asInsert[i]) === -1) {
                newChildList += "," + asInsert[i];
            }
        }

        if (newChildList.indexOf(",") === 0) {
            newChildList = newChildList.substr(1);
        }

        return newChildList;
    }

    getElapsedTime( startDate, endDate) {

        Assert.checkArgument( endDate );

        let x = endDate.getTime() - startDate.getTime(),
            t = x / (1000 * 60 * 60),

            // hours
            h = Math.floor(t),

            // minutes
            m,

            // seconds
            s;

        // Rest in h
        t -= h;
        t *= 60;

        m = Math.floor(t);

        t -= m;
        t *= 60;

        s = Math.ceil(t);

        return ((h <= 9) ? ("0" + h) : h) + ":" + ((m <= 9) ? ("0" + m) : m) + ":" + ((s <= 9) ? ("0" + s) : s);
    }


    /***********************************************************************
     * returns the time since this API ist initialized (Format: 00:00:00).
     * @param {Date} startDate
     * @return {String} time string
     ***********************************************************************/
    getLapsedTime( startDate ) {

        Assert.checkArgument( startDate );
        Assert.checkArgumentType( startDate.getTime, "function" );

        return this.getElapsedTime(startDate, new Date());
    }

    /***********************************************************************
     * returns the better value of two given scores
     * @param {String} scoreValueA
     * @param {String} scoreValueB
     * @return {String} score
     ***********************************************************************/
    getImprovedScore( scoreValueA, scoreValueB ) {

        try {
            const scoreA = castStringScoreToNumber( scoreValueA );
            const scoreB = castStringScoreToNumber( scoreValueB );
            return scoreA > scoreB ? scoreValueA : scoreValueB;
        } catch (e) {
            LoggingService.error(e.message, "Exception while getting improved score");
            return scoreValueA;
        }
    }

    /***********************************************************************
     * returns a score value between 0 and 1
     * @param {String} scoreValue
     * @return {String} score
     ***********************************************************************/
    getScaledScore( scoreValue ){

        let score;

        try {
            score = castStringScoreToNumber( scoreValue );
        } catch (e) {
            LoggingService.error(e.message, "Exception while casting score");
            return scoreValue;
        }

        if( score > 100 ) {
            return "1";
        }

        if( score < 0 ) {
            return "0";
        }

        if( score > 1 ) {
            return (score / 100).toString();
        }

        return scoreValue;
    }
}

export const ScormUtils = new ScormUtilsClass();
